module.exports = __webpack_public_path__ + "media/images/t_logo-0383fb470416b403a5ea680cf1fa47e6.png";